<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class CarsStoreMixin extends Vue {
        get productStore() {
            return carsRentStore
        }

        get productRuntimeStore() {
            return carsRentRuntimeStore
        }

        get productType() {
            return 'carsRent'
        }
    }

    export default CarsStoreMixin
</script>
